import React from "react";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import store from "./store";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store} id="provide">
      <App id="app" />
    </Provider>
  </React.StrictMode>
);
